import styled from "styled-components";

export const ContainerEducation = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5rem;
    padding: 0 5rem;
`
export const ContentEducation = styled.div`
    color: #ffffff;
`